import { ArrayUtils } from "../../../Global/Base/Utils/ArrayUtils";

export class BigIntOps {
    public static bigUIntToString(uint8Array: Uint8Array, radix: number = 10): string {
        const a = ArrayUtils.copyUint8Array(uint8Array);
        let result = "";
        let length = a.length;
        while (length > 0) {
            const rem = BigIntOps._singleByteDivideInPlace(a, length, radix);
            result = BigIntOps._characterSet[rem] + result;
            length = BigIntOps._normalizeLenght(a, length);
        }
        return result;
    }

    public static decimalToString(uint8Array: Uint8Array, scale: number, isNegative: boolean): string {
        const a = ArrayUtils.copyUint8Array(uint8Array);
        let result = "";
        let length = a.length;
        while (length > 0) {
            const rem = BigIntOps._singleByteDivideInPlace(a, length, 10);
            result = BigIntOps._characterSet[rem] + result;
            if (scale && (result.length == scale))
                result = "." + result;
            length = BigIntOps._normalizeLenght(a, length);
        }
        if (isNegative)
            result = "-" + result;
        return result;
    }

    private static _characterSet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    private static _normalizeLenght(data: Uint8Array, length: number): number {
        while (length > 0 && data[length - 1] == 0)
            length--;
        return length;
    }

    private static _singleByteDivideInPlace(data: Uint8Array, length: number, d: number): number {
        let r = 0;
        let i = length;

        while (i-- > 0) {
            r <<= 8;
            r |= data[i];
            data[i] = r / d >> 0; //rychlejsi varianta Math.floor(r / d); - a mimochodem funguje korektne treba i pro -100/3
            r %= d;
        }
        return r;
    }
}
